/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { IconChevronLeft } from "@tabler/icons-react";
import {
  useFetchOrderDetailsData,
  useFetchOrderDetailsStatusHistoryData,
  useOrderDeleteMutation,
  useOrderSyncMutation,
  useOrderUpdateMutation,
} from "../../apis/orderApis";
import formatDate, { formatTime } from "../../utilities/helper";
import EditOrderModal from "./_components/EditOrderModal";
import { OrderFormData } from "../../types/types";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import SmsModal from "./_components/SmsModal";
import DeleteModal from "./_components/DeleteModal";
import LabelPrintModal from "./_components/LabelPrintModal";
import Forword3PlModal from "./_components/Forword3PlModal";
import { useSelector } from "react-redux";
import { usePermission } from "../../hooks/usePermissionTabs";
import { T, useLanguage } from "../../context/LanguageContext";
import ListView from "../../components/common/ListView";

const Row = ({
  label,
  value,
  icon2,
  className = "",
}: {
  icon2?: React.ReactNode;
  label: string;
  className?: string;
  value: React.ReactNode;
}) => {
  const { t } = useLanguage();
  return (
    <div
      className={`flex items-center justify-between gap-2 py-1.5 px-4 ${className}`}
    >
      <div className="flex items-center gap-2">
        <span className="font-bold text-sm text-[#212121]">{t(label)}: </span>
      </div>
      <div className="flex items-center gap-2">
        <span className="break-all text-sm text-[#212121]">{value}</span>
        {icon2 && <div className="mt-0.5 text-gray-500">{icon2}</div>}
      </div>
    </div>
  );
};

const DetailBox = ({ label, value }: { label: string; value: any }) => (
  <div className="flex items-center justify-between gap-2 py-1.5 px-4">
    <div className="flex items-center gap-2">
      <span className="font-bold text-sm text-[#212121]">
        <T>{label}</T>:{" "}
      </span>
    </div>
    <div className="flex items-center gap-2">
      <span className="break-all text-sm text-[#212121]">
        {typeof value === "string" ? <T>{value}</T> : value || ""}
      </span>
    </div>
  </div>
);

export default function ViewOrderDetails() {
  const { t } = useLanguage();
  const { allowed: canUpdateOrder } = usePermission("orders", "update");
  const { allowed: canDeleteOrder } = usePermission("orders", "delete");

  const { awb } = useParams();
  const navigate = useNavigate();

  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isSmsOpen, setIsSmsOpen] = useState(false);
  const [isForword3PlOpen, setIsForword3PlOpen] = useState(false);
  const [showLabelModal, setShowLabelModal] = useState(false);
  const [order, setOrder] = useState<any>();

  const profile = useSelector((state: any) => state.auth.profile);

  const { data, refetch: refetchDetails } = useFetchOrderDetailsData(awb ?? "");
  const { data: statusHistories, refetch: refetchHistory } =
    useFetchOrderDetailsStatusHistoryData(awb ?? "");

  const { mutate: deleteMutate, isPending: isDeletePending } =
    useOrderDeleteMutation(data?.id ?? "");
  const { mutate: updateMutate, isPending: isUpdatePending } =
    useOrderUpdateMutation(data?.id ?? "");
  const { mutate: syncMutate } = useOrderSyncMutation();

  const refreshAllDetails = () => {
    refetchDetails();
    refetchHistory();
  };

  const {
    register,
    setValue,
    clearErrors,
    formState: { errors },
    watch,
    handleSubmit,
  } = useForm<OrderFormData>();

  const {
    register: forwardRegister,
    setValue: setForwardValue,
    clearErrors: forwardClearErrors,
    formState: { errors: forwardErrors },
    watch: forwardWatch,
    handleSubmit: handleForwardSubmit,
  } = useForm<any>();

  const {
    register: deleteRegister,
    setValue: deleteSetValue,
    clearErrors: deleteClearErrors,
    formState: { errors: deleteErrors },
    watch: deleteWatch,
    reset: deleteReset,
    handleSubmit: deleteHandleSubmit,
  } = useForm<any>();

  const closeEditModal = () => setIsEditOpen(false);
  const closeDeleteModal = () => setIsDeleteOpen(false);
  const closeSmsModal = () => setIsSmsOpen(false);
  const openSmsModal = () => {
    setIsSmsOpen(true);
    setIsEditOpen(false);
    setIsForword3PlOpen(false);
    setIsDeleteOpen(false);
    setShowLabelModal(false);
  };
  const closeForword3PlModal = () => setIsForword3PlOpen(false);
  const openForword3PlModal = (orderData: any) => {
    setOrder(orderData);
    setIsForword3PlOpen(true);
    setIsEditOpen(false);
    setIsSmsOpen(false);
    setIsDeleteOpen(false);
    setShowLabelModal(false);
  };

  const openEditModal = (orderData: any) => {
    setOrder(orderData);
    setShowLabelModal(false);
    setIsDeleteOpen(false);
    setIsForword3PlOpen(false);
    setIsSmsOpen(false);
    setIsEditOpen(true);
  };

  const openDeleteModal = (orderData: any) => {
    setOrder(orderData);
    setIsEditOpen(false);
    setIsForword3PlOpen(false);
    setIsSmsOpen(false);
    setShowLabelModal(false);
    setIsDeleteOpen(true);
  };

  const handleLabelPrint = (orderData: any) => {
    setOrder(orderData);
    setIsEditOpen(false);
    setIsDeleteOpen(false);
    setIsForword3PlOpen(false);
    setIsSmsOpen(false);
    setShowLabelModal(true);
  };

  const deleteOrder = (formData: any) => {
    const payload = {
      ...formData,
      warehouseId: profile?.warehouse,
    };
    deleteMutate(payload, {
      onSuccess: () => {
        deleteReset();
        setIsDeleteOpen(false);
        toast.success("Order deleted successfully");
        navigate("/orders");
      },
      onError: (error: any) => {
        console.error(error, "error");
        toast.error(error.message || "Failed to delete order");
      },
    });
  };

  const handleUpdateOrder = (formData: any) => {
    updateMutate(formData, {
      onSuccess: () => {
        setIsEditOpen(false);
        refreshAllDetails();
        toast.success("Order updated successfully");
      },
      onError: (error: any) => {
        console.error(error, "error");
        toast.error(error.message || "Failed to update order");
      },
    });
  };

  const formatStatus = (status: string) => {
    return status
      ?.toLowerCase()
      ?.split("_")
      ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      ?.join(" ");
  };

  const isOutlet = data?.platform === "OUTLET";
  const isDataReady = data && String(data?.awbNumber) === String(awb);
  const steps = isDataReady ? statusHistories || [] : [];
  const currentStep = steps.length - 1;

  const [activeDetailsTab, setActiveDetailsTab] = useState<"specs" | "items">(
    "specs"
  );
  const [activeRightTab, setActiveRightTab] = useState<
    "sender" | "receiver" | "shipment"
  >("sender");

  const itemsCardRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleWheel = (event: WheelEvent) => {
      event.preventDefault();
      container.scrollLeft += event.deltaY;
    };

    container.addEventListener("wheel", handleWheel, { passive: false });
    return () => {
      container.removeEventListener("wheel", handleWheel);
    };
  }, []);

  const isNewOrder = data?.status?.toUpperCase() === "NEW_ORDER";
  const hasItems = data?.olineItems && data.olineItems.length > 0;
  const showItems = !!hasItems;

  useEffect(() => {
    if (showItems && isNewOrder) {
      setActiveDetailsTab("items");
    } else {
      setActiveDetailsTab("specs");
    }
  }, [isNewOrder, showItems]);

  const orderStatus = data?.status?.toUpperCase() || "";
  const isShipped =
    [
      "DISPATCHED",
      "IN_TRANSIT",
      "OUT_FOR_DELIVERY",
      "DELIVERED",
      "FORWARD_TO_3PL",
      "DEPARTED",
      "PICKED_UP",
    ].includes(orderStatus) || !!data?.shippingAwbNumber;

  const formatStatusName = (status: string): string => {
    const map: Record<string, string> = {
      DRAFT: "Draft",
      NEW_ORDER: "New Order",
      ORDER_CREATED: "Order Created",
      PROCESSING: "Processing",
      READY_FOR_PICKUP: "Ready for Pickup",
      PICKUP_GENERATED: "Pickup Generated",
      PICKUP_COLLECTED: "Pickup Collected",
      RECEIVE_INBOUND: "Receive Inbound",
      RECEIVE_IN_WAREHOUSE: "Received in Warehouse",
      SHELVE: "Shelving",
      SHELVED: "Shelved",
      IN_WAREHOUSE: "In Warehouse",
      ARRIVED_AT_WAREHOUSE: "Arrived at Warehouse",
      DISPATCHED: "Dispatched",
      DISPATCHED_TO_3PL: "Dispatched to 3PL",
      FORWARD_TO_3PL: "Forwarded to 3PL",
      IN_TRANSIT: "In Transit",
      OUT_FOR_DELIVERY: "Out for Delivery",
      DEPARTED: "Departed",
      PICKED_UP: "Picked Up",
      DELIVERED: "Delivered",
      NOT_DELIVERED: "Not Delivered",
      RETURNED: "Returned",
      RETURN_TO_SHIPPER: "Return to Shipper",
      REVERSE_NEW: "Reverse Order",
      REVERSE_ORDER: "Reverse Order",
      CANCELLED: "Cancelled",
      FAILED: "Failed",
      LOST: "Lost",
      DAMAGE: "Damaged",
      PENDING: "Pending",
      PENDING_STOCK: "Pending Stock",
      PICKLIST_GENERATED: "Picklist Generated",
      PICKED: "Picked",
      PACKED: "Packed",
      REVERTED: "Reverted",
      DELETED: "Deleted",
    };
    return (
      map[status?.toUpperCase()] ||
      status?.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) ||
      status
    );
  };

  const TERMINAL_STATUSES = [
    "DELIVERED",
    "CANCELLED",
    "FAILED",
    "RETURNED",
    "LOST",
    "DELETED",
    "DAMAGE",
    "RETURN_TO_SHIPPER",
    "NOT_DELIVERED",
  ];
  const isTerminal = TERMINAL_STATUSES.includes(orderStatus);

  const buildDynamicMilestones = () => {
    if (!steps || steps.length === 0) {
      const fallback = [
        {
          title: formatStatusName(data?.status || "New Order"),
          subtitle: "",
          date: data?.createdAt || null,
          logEntry: null,
          isFuture: false,
        },
      ];
      if (!isTerminal) {
        fallback.push({
          title: "Delivered",
          subtitle: "Awaiting hand-off",
          date: null,
          logEntry: null,
          isFuture: true,
        });
      }
      return fallback;
    }

    const seen = new Set<string>();
    const unique = steps.filter((h: any) => {
      const key = h.status?.toUpperCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });

    const milestones = unique.map((h: any) => ({
      title: formatStatusName(h.status),
      subtitle: h.details || h.comment || "",
      date: h.createdAt || null,
      logEntry: h,
      isFuture: false,
    }));

    return milestones;
  };

  const dynamicMilestones = buildDynamicMilestones();
  const currentActiveStep = dynamicMilestones.reduce(
    (acc: number, m: any, idx: number) => (!m.isFuture ? idx : acc),
    0
  );

  const hasVariantData = data?.olineItems?.some(
    (item: any) => item?.optionName && item?.optionValue
  );

  const shouldShowClientId = data?.subStatus !== "reverseOrder";
  const displayClientId = shouldShowClientId ? (data?.clientId ?? "") : "";
  const displayCompanyName = shouldShowClientId ? data?.clientName || "" : "";

  return (
    <>
      <div className="px-6 space-y-6" style={{ fontFamily: '"Inter Tight", sans-serif' }}>
        <div className="grid grid-cols-1 lg:grid-cols-12 p-2 bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 w-full rounded-3xl relative">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />

          {/* Header / Waybill */}
          <div className="lg:col-span-8 bg-white/20 backdrop-blur-sm px-4 py-2 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate(-1)}
                className="p-1.5 border border-slate-200 rounded-lg text-slate-600 bg-white hover:bg-slate-50 transition shadow-sm shrink-0"
              >
                <IconChevronLeft strokeWidth={1.5} size={16} />
              </button>
              <div>
                <h2 className="text-xl font-bold text-slate-800 tracking-tight">
                  {awb}
                </h2>
              </div>
            </div>
          </div>

          <div className="relative lg:col-span-4 bg-white/20 px-4 py-2">
            <div className="flex items-center justify-between">
              <div></div>
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-[11px] font-bold px-2.5 p-1.5 rounded-lg bg-emerald-50 text-emerald-700 border border-emerald-200/70 uppercase tracking-wide">
                  <T>{data?.status ? formatStatus(data.status) : "ACTIVE"}</T>
                </span>
                {data?.status !== "DELETED" && (
                  <>
                    {canUpdateOrder && (
                      <button
                        onClick={() => openEditModal(data)}
                        className="flex items-center gap-1 p-1.5 rounded-lg border border-slate-200"
                      >
                        <img
                          src="/img/dashboard-icons/edit.svg"
                          className="size-4"
                          alt="edit"
                        />
                      </button>
                    )}
                    <button
                      onClick={() => handleLabelPrint(data)}
                      className="flex items-center gap-1 p-1.5 rounded-lg border border-slate-200"
                    >
                      <img
                        src="/img/dashboard-icons/print.svg"
                        className="size-4"
                        alt="print"
                      />
                    </button>
                    {canDeleteOrder && (
                      <button
                        onClick={() => openDeleteModal(data)}
                        className="flex items-center gap-1 p-1.5 rounded-lg border border-slate-200"
                      >
                        <img
                          src="/img/dashboard-icons/trash.svg"
                          className="size-4"
                          alt="delete"
                        />
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>

            {(isEditOpen || showLabelModal || isDeleteOpen) && (
              <div className="absolute top-14 z-[9999] right-6 md:w-[600px] w-11/12 rounded-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">
                {isEditOpen && (
                  <EditOrderModal
                    open={isEditOpen}
                    onClose={closeEditModal}
                    order={order}
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    watch={watch}
                    clearErrors={clearErrors}
                    handleSubmit={handleSubmit(handleUpdateOrder)}
                    isPending={isUpdatePending}
                    inPlace
                  />
                )}

                {showLabelModal && (
                  <LabelPrintModal
                    open={showLabelModal}
                    onClose={() => setShowLabelModal(false)}
                    order={order}
                    inPlace
                  />
                )}

                {isDeleteOpen && (
                  <DeleteModal
                    open={isDeleteOpen}
                    onClose={closeDeleteModal}
                    deleteOrder={deleteHandleSubmit(deleteOrder)}
                    isDeletePending={isDeletePending}
                    register={deleteRegister}
                    clearErrors={deleteClearErrors}
                    watch={deleteWatch}
                    setValue={deleteSetValue}
                    errors={deleteErrors}
                    inPlace
                  />
                )}
              </div>
            )}
          </div>

          {/* Timeline Full Width */}
          <div className="lg:col-span-12 bg-white/20 backdrop-blur-sm px-4 transition-all">
            <h3 className="text-base font-semibold text-slate-800">
              <T>Timeline</T>
            </h3>

            <div
              ref={containerRef}
              className="overflow-x-auto overflow-y-hidden relative scroll-smooth"
              style={{ scrollBehavior: "smooth" }}
            >
              {/* Timeline line */}
              <div
                className="absolute top-[70px] left-[120px] h-[2px] bg-gray-300"
                style={{
                  width: `${(dynamicMilestones.length - 1) * 260}px`,
                }}
              />

              <div
                className="flex items-start gap-[50px] relative py-8"
                style={{ minWidth: `${dynamicMilestones.length * 200}px` }}
              >
                {dynamicMilestones.map((milestone: any, index: number) => {
                  const isCompleted = index < currentActiveStep;
                  const isCurrent = index === currentActiveStep;

                  return (
                    <div
                      key={index}
                      className="group relative w-[200px] flex-shrink-0"
                    >
                      <div
                        className={`relative overflow-hidden rounded-lg shadow-md transition-all duration-300 h-[60px] group-hover:h-fit pb-2 ${
                          isCompleted
                            ? "bg-[#A8E6A2]"
                            : isCurrent
                            ? "bg-[#FBD037]"
                            : "bg-gray-200"
                        }`}
                      >
                        <div className="opacity-0 group-hover:opacity-100 transition-all duration-300 pt-1 group-hover:pt-4">
                          {milestone.logEntry && (
                            <p className="text-[10px] font-semibold text-center text-[#212121]/70">
                              {formatDate(milestone.logEntry.createdAt)}{" "}
                              {formatTime(milestone.logEntry.createdAt)}
                            </p>
                          )}
                        </div>
                        <div
                          className={`flex justify-center items-center transition-all duration-300 group-hover:mt-0 `}
                        >
                          <h3 className="font-medium text-[#212121] text-md text-center px-4">
                            <T>{milestone.title}</T>
                          </h3>
                        </div>
                        <div className="opacity-0 group-hover:opacity-100 transition-all duration-300 px-2">
                          {(milestone.logEntry?.userName ||
                            milestone.logEntry?.assignedUser) && (
                            <div className="flex justify-center items-center gap-1">
                              <span className="bg-yellow-50 text-[#212121] rounded px-1 py-1 text-[9px] font-medium shadow">
                                {milestone.logEntry.userName ? (
                                  <>
                                    <T>
                                      {milestone.logEntry.userType || "User"}
                                    </T>
                                    : {milestone.logEntry.userName}
                                  </>
                                ) : (
                                  <>Driver: {milestone.logEntry.assignedUser}</>
                                )}
                              </span>

                              {milestone.logEntry.warehouseName && (
                                <span className="bg-yellow-50 text-[#212121] rounded px-1 py-1 text-[9px] font-medium shadow">
                                  <T>{milestone.logEntry.warehouseName}</T>
                                </span>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Left Content */}
          <div
            ref={itemsCardRef}
            className="lg:col-span-8 bg-white/20 backdrop-blur-sm transition-all"
          >
            <div className="flex justify-between items-center px-4 py-2 text-[#131327]/70 border-b border-t border-dashed border-gray-300 sticky top-0 z-20 shadow-sm bg-[#FCFDF8]">
              <h3 className="text-base font-bold">
                {activeDetailsTab === "specs" ? (
                  <T>Shipment Details</T>
                ) : (
                  <T>Product Details</T>
                )}
              </h3>

              {showItems && (
                <div className="flex bg-slate-100 p-0.5 rounded-full border border-slate-200 shrink-0">
                  <button
                    onClick={() => setActiveDetailsTab("specs")}
                    className={`py-1 px-3.5 rounded-full text-xs font-bold transition ${
                      activeDetailsTab === "specs"
                        ? "bg-white text-slate-800 shadow-sm border border-slate-200/40"
                        : "text-slate-500 hover:text-slate-700"
                    }`}
                  >
                    <T>Shipment</T>
                  </button>
                  <button
                    onClick={() => setActiveDetailsTab("items")}
                    className={`py-1 px-3.5 rounded-full text-xs font-bold transition ${
                      activeDetailsTab === "items"
                        ? "bg-white text-slate-800 shadow-sm border border-slate-200/40"
                        : "text-slate-500 hover:text-slate-700"
                    }`}
                  >
                    <T>Product</T>
                  </button>
                </div>
              )}
            </div>

            <div>
              {activeDetailsTab === "specs" ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-y-1">
                  <div className="divide-y border-b border-l">
                    <DetailBox
                      label="Entry Date"
                      value={formatDate(data?.createdAt)}
                    />
                    <DetailBox label="Platform" value={data?.platform} />
                    <DetailBox
                      label="Reference"
                      value={data?.referenceNumber}
                    />
                    <DetailBox
                      label="Shipper Reference"
                      value={data?.shipperReferenceNumber || ""}
                    />
                    <DetailBox label="Warehouse" value={data?.warehouseName} />
                    <DetailBox
                      label="Shelf"
                      value={
                        data?.shelfLocation
                          ? `${data.shelfLocation} - ${data.shelfNo || ""}`
                          : data?.shelfNo || ""
                      }
                    />
                    <DetailBox
                      label="Product Category"
                      value={data?.shipmentType || "PARCEL"}
                    />
                    <DetailBox
                      label="No Of Pieces"
                      value={data?.noOfPieces || ""}
                    />
                  </div>
                  <div className="divide-y border-b border-l border-r">
                    <DetailBox
                      label="Close Date"
                      value={
                        data?.closedDate ? formatDate(data.closedDate) : ""
                      }
                    />

                    <DetailBox
                      label="Payment Mode"
                      value={`${data?.paymentType ? t(data.paymentType) : "—"} - ${data?.codAmount || "0.00"} ${t("SAR")}`}
                    />
                    <DetailBox
                      label="Route Details"
                      value={`${data?.routeCode || ""} / ${data?.routeName || ""}`}
                    />
                    <DetailBox
                      label="Delivery Attempts"
                      value={
                        data?.totalDeliveryAttempt !== undefined
                          ? String(data.totalDeliveryAttempt)
                          : "0"
                      }
                    />
                    <DetailBox
                      label="Weight"
                      value={
                        data?.totalWeight
                          ? `${data.totalWeight} ${t("KG")}`
                          : `0.00 ${t("KG")}`
                      }
                    />
                    <DetailBox
                      label="Pieces"
                      value={
                        data?.noOfPieces
                          ? `${data.noOfPieces} ${t("item")}`
                          : `${data?.olineItems?.length || 0} ${t("item")}`
                      }
                    />
                    <DetailBox
                      label="Service"
                      value={data?.serviceType || "Standard"}
                    />
                  </div>
                </div>
              ) : (
                /* Items Tab */
                data?.olineItems?.length > 0 && (
                  <ListView
                    mailDivClassName=""
                    data={data?.olineItems || []}
                    columns={[
                      {
                        label: <T>SKU</T>,
                        render: (item: any) => (
                          <div className=""> {item.sku || "—"} </div>
                        ),
                      },
                      {
                        label: <T>Product Name</T>,
                        render: (item: any) => (
                          <div className=" "> {item.itemName || "—"} </div>
                        ),
                      },
                      {
                        label: <T>Qty</T>,
                        render: (item: any) => (
                          <div className=" "> {item.quantity ?? "—"} </div>
                        ),
                      },
                      {
                        label: <T>Weight</T>,
                        render: (item: any) => (
                          <div className=" ">
                            {" "}
                            {item.weight ? `${item.weight} Kg` : "—"}{" "}
                          </div>
                        ),
                      },
                      {
                        label: <T>Price</T>,
                        render: (item: any) => (
                          <div className=" "> {item.price ?? "—"} </div>
                        ),
                      },
                      ...(hasVariantData
                        ? [
                            {
                              label: <T>Variant</T>,
                              render: (item: any) => (
                                <div className=" ">
                                  {" "}
                                  {item.optionValue || "—"}{" "}
                                </div>
                              ),
                            },
                          ]
                        : []),
                      {
                        label: <T>Description</T>,
                        render: (item: any) => (
                          <div className=" " title={item.description || ""}>
                            {" "}
                            {item.description || "—"}{" "}
                          </div>
                        ),
                      },
                    ]}
                  />
                )
              )}
            </div>
          </div>

          {/* Right Sidebar */}
          <div className="lg:col-span-4 lg:sticky lg:top-6 self-start space-y-4">
            <div className="bg-white/20 backdrop-blur-sm">
              <div className="flex justify-between items-center px-4 py-2 text-[#131327]/70 border-l border-b border-t border-dashed border-gray-300 sticky top-0 z-20 shadow-sm bg-[#FCFDF8]">
                <h3 className="text-base font-semibold">
                  {activeRightTab === "sender" ? (
                    <T>Sender Details</T>
                  ) : activeRightTab === "receiver" ? (
                    <T>Receiver Details</T>
                  ) : (
                    <T>Shipping Details</T>
                  )}
                </h3>

                <div className="flex bg-slate-100 p-0.5 rounded-full border border-slate-200 shrink-0">
                  <button
                    onClick={() => setActiveRightTab("sender")}
                    className={`py-1 px-3.5 rounded-full text-xs font-medium transition ${
                      activeRightTab === "sender"
                        ? "bg-white text-slate-800 shadow-sm border border-slate-200/40"
                        : "text-slate-500 hover:text-slate-700"
                    }`}
                  >
                    <T>Sender</T>
                  </button>

                  <button
                    onClick={() => setActiveRightTab("receiver")}
                    className={`py-1 px-3.5 rounded-full text-xs font-medium transition ${
                      activeRightTab === "receiver"
                        ? "bg-white text-slate-800 shadow-sm border border-slate-200/40"
                        : "text-slate-500 hover:text-slate-700"
                    }`}
                  >
                    <T>Receiver</T>
                  </button>

                  {isShipped && (
                    <button
                      onClick={() => setActiveRightTab("shipment")}
                      className={`py-1 px-3.5 rounded-full text-xs font-medium transition ${
                        activeRightTab === "shipment"
                          ? "bg-white text-slate-800 shadow-sm border border-slate-200/40"
                          : "text-slate-500 hover:text-slate-700"
                      }`}
                    >
                      <T>Shipment</T>
                    </button>
                  )}
                </div>
              </div>

              {activeRightTab === "sender" && (
                <div className="divide-y">
                  <Row
                    label={"Company Name"}
                    value={
                      <T>
                        {isOutlet
                          ? data?.outletName || "—"
                          : displayCompanyName || "—"}
                      </T>
                    }
                  />
                  <Row
                    label={"Account Ref No"}
                    value={
                      isOutlet ? (
                        <span className="inline-block bg-slate-50 border border-slate-200 rounded-lg px-2.5 py-0.5 text-slate-700 text-[10px] font-semibold">
                          {data?.outletCode || "—"}
                        </span>
                      ) : displayClientId ? (
                        <span className="inline-block bg-slate-50 border border-slate-200 rounded-lg px-2.5 py-0.5 text-slate-700 text-[10px] font-semibold">
                          {displayClientId}
                        </span>
                      ) : (
                        <p className="text-sm font-medium text-slate-400">—</p>
                      )
                    }
                  />
                </div>
              )}

              {activeRightTab === "receiver" && (
                <div className="divide-y">
                  <Row
                    label={"Full Name"}
                    value={<T>{data?.receiverName || "—"}</T>}
                  />
                  <Row label={"Mobile"} value={data?.receiverMobile || "—"} />
                  <Row label={"Email"} value={data?.receiverEmail || "—"} />
                  <Row
                    label={"Address"}
                    value={
                      <T>
                        {data?.receiverAddress
                          ? data.receiverAddress.replace(/<[^>]*>/g, "")
                          : "—"}
                      </T>
                    }
                  />
                  <Row
                    label="City"
                    value={
                      <T>
                        {data?.receiverCityName ||
                          data?.receiverCityData ||
                          "—"}
                      </T>
                    }
                  />
                  <Row
                    label="District"
                    value={
                      <>
                        {(data?.receiverDistrictName ||
                          data?.receiverDistrictData) && (
                          <T>
                            {data?.receiverDistrictName ||
                              data?.receiverDistrictData}
                          </T>
                        )}
                      </>
                    }
                  />
                  <Row
                    label="Short Address"
                    value={data?.receiverNationalAddress}
                  />
                  <Row
                    label="Coordinates"
                    value={
                      data?.receiverLatitude && data?.receiverLongitude
                        ? `${Number(data.receiverLatitude).toFixed(4)}, ${Number(data.receiverLongitude).toFixed(4)}`
                        : "—"
                    }
                  />
                </div>
              )}

              {activeRightTab === "shipment" && isShipped && (
                <div className="divide-y">
                  <Row
                    label="Forwarded Date"
                    value={
                      data?.shippingCreatedAt
                        ? formatDate(data.shippingCreatedAt)
                        : " "
                    }
                  />
                  <Row
                    label="Forwarded Company"
                    value={<T>{data?.shippingCompany || " "}</T>}
                  />
                  <Row
                    label="Forwarded AWB No"
                    value={data.shippingAwbNumber}
                  />
                  <Row
                    label="Forwarded Pieces"
                    value={data.shippingPieces || ""}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
